(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-psylos-about-fade]');
  if (!roots.length || !('IntersectionObserver' in window)) {
    roots.forEach(function (r) {
      var c = r.querySelector('.psylos-about--fade');
      if (c) { c.classList.add('is-visible'); }
    });
    return;
  }
  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  roots.forEach(function (r) {
    var c = r.querySelector('.psylos-about--fade');
    if (c) { io.observe(c); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-banner-mini"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.psylos-banner-mini--aos:not([data-pbm-init])');
  if (!roots.length) return;
  if (!('IntersectionObserver' in window) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    roots.forEach(function (el) { el.setAttribute('data-pbm-init', '1'); el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  roots.forEach(function (el) { el.setAttribute('data-pbm-init', '1'); io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-best-seller"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBestSeller(root) {
    if (!root || root.dataset.pbsInit === '1') return;
    root.dataset.pbsInit = '1';

    var tabs = root.querySelectorAll('[data-pbs-tab]');
    var panels = root.querySelectorAll('[data-pbs-panel]');

    function activate(index) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-pbs-tab') === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-pbs-panel') === String(index);
        panel.classList.toggle('is-active', on);
        if (on) { panel.removeAttribute('hidden'); }
        else { panel.setAttribute('hidden', ''); }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-pbs-tab'));
      });
      tab.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = list[(i + 1) % list.length]; }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = list[(i - 1 + list.length) % list.length]; }
        if (next) {
          e.preventDefault();
          activate(next.getAttribute('data-pbs-tab'));
          next.focus();
        }
      });
    });

    // Scroll fade-in
    var reveals = root.querySelectorAll('[data-pbs-reveal]');
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  function initAll() {
    document.querySelectorAll('.psylos-best-seller').forEach(initBestSeller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.psylos-best-seller');
    if (root) { root.dataset.pbsInit = ''; initBestSeller(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-blog-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    if (root.dataset.pbsInit === '1') return;
    root.dataset.pbsInit = '1';

    var track = root.querySelector('[data-pbs-track]');
    var dotsWrap = root.querySelector('[data-pbs-dots]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.psylos-blog-slider__card'));
    if (!cards.length) return;

    // Build one dot per card.
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach(function (card, i) {
        var dot = document.createElement('li');
        dot.className = 'psylos-blog-slider__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', '0');
        dot.setAttribute('aria-label', 'Go to post ' + (i + 1));
        dot.addEventListener('click', function () { scrollToCard(card); });
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToCard(card); }
        });
        dotsWrap.appendChild(dot);
      });
    }

    function scrollToCard(card) {
      var left = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }

    function setActive(idx) {
      if (!dotsWrap) return;
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }

    // Sync active dot to the card nearest the track centre.
    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (card, i) {
          var cc = card.offsetLeft + card.clientWidth / 2;
          var d = Math.abs(cc - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        setActive(best);
      });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-psylos-blog-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init in the theme editor when this section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-psylos-blog-slider]');
    if (root) { root.dataset.pbsInit = ''; initSlider(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.psylos-coll');
  roots.forEach(function (root) {
    // Sort: reload with ?sort_by=
    var sel = root.querySelector('[data-pc-sort]');
    if (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Grid density toggles (client-side, desktop only)
    var grid = root.querySelector('[data-pc-grid]');
    var btns = root.querySelectorAll('[data-pc-cols]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-pc-cols');
        if (grid) grid.style.setProperty('--pc-cols-d', cols);
        btns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          if (on) { b.setAttribute('aria-pressed', 'true'); } else { b.removeAttribute('aria-pressed'); }
        });
      });
    });

    // Filter button -> open the filter drawer
    var fbtn = root.querySelector('[data-pc-filter-toggle]');
    var fdrawer = root.querySelector('[data-pc-filter-drawer]');
    function pcOpenFilter() {
      if (!fdrawer) return;
      fdrawer.hidden = false;
      requestAnimationFrame(function () { fdrawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      if (fbtn) fbtn.setAttribute('aria-expanded', 'true');
    }
    function pcCloseFilter() {
      if (!fdrawer) return;
      fdrawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (fbtn) fbtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!fdrawer.classList.contains('is-open')) fdrawer.hidden = true; }, 320);
    }
    if (fbtn) fbtn.addEventListener('click', pcOpenFilter);
    root.querySelectorAll('[data-pc-filter-close]').forEach(function (b) { b.addEventListener('click', pcCloseFilter); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && fdrawer && fdrawer.classList.contains('is-open')) pcCloseFilter(); });

    // "Show more" inside a facet
    root.querySelectorAll('[data-pc-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.closest('.psylos-coll__facet');
        if (facet) facet.querySelectorAll('.pc-extra').forEach(function (li) { li.hidden = false; });
        btn.style.display = 'none';
      });
    });

    // Collapsible filter sections (accordion)
    root.querySelectorAll('[data-pc-facet-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.closest('[data-pc-facet]');
        if (!facet) return;
        var collapsed = facet.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', String(!collapsed));
      });
    });

    // Breadcrumb -> open the header's mobile sidebar (reuse the hamburger's existing drawer)
    var crumbBtn = root.querySelector('[data-pc-sidebar-open]');
    if (crumbBtn) {
      crumbBtn.addEventListener('click', function () {
        var ham = document.querySelector('.ph-hamburger');
        if (ham) ham.click();
      });
    }
  });
})();
(function(){
  function initCard(card){
    if(card.dataset.pcardInit==='1')return; card.dataset.pcardInit='1';
    var wrap=card.querySelector('[data-pcard-media]'); if(!wrap)return;
    var slides=Array.prototype.slice.call(wrap.querySelectorAll('.psylos-card__slide'));
    var dots=Array.prototype.slice.call(card.querySelectorAll('.psylos-card__dot'));
    if(slides.length<2)return;
    function setActive(i){ if(i<0)i=0; if(i>=slides.length)i=slides.length-1;
      slides.forEach(function(s,si){s.classList.toggle('is-active',si===i);});
      dots.forEach(function(d,di){d.classList.toggle('is-active',di===i);}); }
    if(window.matchMedia('(hover:hover) and (min-width:768px)').matches){
      wrap.addEventListener('mousemove',function(e){ var r=wrap.getBoundingClientRect(); if(r.width<=0)return;
        setActive(Math.floor((e.clientX-r.left)/r.width*slides.length)); });
      wrap.addEventListener('mouseleave',function(){ setActive(0); });
    }
    var raf=null;
    wrap.addEventListener('scroll',function(){ if(raf)return;
      raf=requestAnimationFrame(function(){ raf=null; var i=Math.round(wrap.scrollLeft/Math.max(1,wrap.clientWidth));
        dots.forEach(function(d,di){d.classList.toggle('is-active',di===i);}); }); },{passive:true});
  }
  function bootCards(){ document.querySelectorAll('[data-psylos-card]').forEach(initCard); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bootCards);}else{bootCards();}
  document.addEventListener('shopify:section:load',bootCards);
})();

(function(){
  function initFade(root){
    if(root.dataset.pcFadeInit==='1')return; root.dataset.pcFadeInit='1';
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;
    var items=Array.prototype.slice.call(root.querySelectorAll('.psylos-coll__item'));
    if(!items.length)return;
    root.classList.add('pc-fade-ready');
    /* Pointer-based sweep: reveal every card whose top has entered the viewport.
       Runs on scroll via requestAnimationFrame, so it stays RELIABLE even on FAST mobile
       scroll — where an IntersectionObserver can skip cards that whip through the trigger
       zone between samples (the user's bug: "fade not applied on quick scroll"). */
    var revealedUpTo=0;
    function sweep(){
      var vh=window.innerHeight||document.documentElement.clientHeight;
      while(revealedUpTo<items.length){
        var it=items[revealedUpTo];
        if(it.classList.contains('is-inview')){revealedUpTo++;continue;}
        if(it.getBoundingClientRect().top < vh*0.96){ it.classList.add('is-inview'); revealedUpTo++; }
        else break; /* items are in DOM (top->bottom) order; the rest are lower/not in view yet */
      }
    }
    /* IntersectionObserver still gives a clean per-card trigger when NOT actively scrolling
       (e.g. images load and shift layout). The sweep above is the fast-scroll safety net. */
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-inview'); io.unobserve(en.target); } });
      },{rootMargin:'0px 0px -4% 0px',threshold:0});
      items.forEach(function(it){io.observe(it);});
    }
    /* Call the cheap pointer-based sweep DIRECTLY on scroll — NOT via requestAnimationFrame,
       which is throttled/paused in background tabs. The pointer + early break keep each call
       to a couple of getBoundingClientRect reads, so direct calls stay reliable on fast scroll. */
    window.addEventListener('scroll',sweep,{passive:true});
    window.addEventListener('resize',sweep,{passive:true});
    sweep();
    setTimeout(sweep,350);
    setTimeout(sweep,1200);
  }
  function bootFade(){ document.querySelectorAll('.psylos-coll--fade').forEach(initFade); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bootFade);}else{bootFade();}
  document.addEventListener('shopify:section:load',bootFade);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-collection-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.psylos-collection-tiles');
  if (!roots.length) return;
  if (!('IntersectionObserver' in window)) {
    roots.forEach(function (root) {
      root.querySelectorAll('.cct-fade').forEach(function (el) { el.classList.add('is-visible'); });
    });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
  roots.forEach(function (root) {
    root.querySelectorAll('.cct-fade').forEach(function (el) { io.observe(el); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-dual-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.psylos-dual-banner');
  sections.forEach(function (section) {
    if (section.dataset.pdbInit === '1') return;
    section.dataset.pdbInit = '1';

    // smooth scroll-to-top on the "back to top" button
    var topBtn = section.querySelector('.js-pdb-top');
    if (topBtn) {
      topBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (section.dataset.anim !== 'true') return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      section.classList.add('in-view');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    observer.observe(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var heroes = document.querySelectorAll('.psylos-hero');
  if (!heroes.length) return;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  if (reduce) return;
  heroes.forEach(function (hero) {
    var layers = hero.querySelectorAll('[data-lp]');
    if (!layers.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var y = -r.top;
      layers.forEach(function (L) {
        var f = parseFloat(L.getAttribute('data-lp')) || 0;
        L.style.transform = 'translate3d(0,' + (y * f).toFixed(1) + 'px,0)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-product-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.psylos-product-carousel--fade');
  if (!roots.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) {
    roots.forEach(function (root) {
      root.querySelectorAll('.psylos-product-carousel__card').forEach(function (c) { c.classList.add('is-visible'); });
    });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var card = entry.target;
        var i = parseInt(card.style.getPropertyValue('--ppc-i'), 10) || 0;
        card.style.transitionDelay = Math.min(i, 6) * 100 + 'ms';
        card.classList.add('is-visible');
        io.unobserve(card);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  roots.forEach(function (root) {
    root.querySelectorAll('.psylos-product-carousel__card').forEach(function (card) { io.observe(card); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initProduct(root) {
    if (!root || root.dataset.ppInit === '1') return;
    root.dataset.ppInit = '1';

    // Thumbnail strip -> scroll matching slide into view (desktop grid: just highlight).
    var thumbs = root.querySelectorAll('[data-pp-thumb]');
    var gallery = root.querySelector('[data-pp-gallery]');
    var slides = root.querySelectorAll('[data-pp-slide]');

    function setActive(index) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-pp-thumb') === String(index));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-pp-thumb');
        var slide = root.querySelector('[data-pp-slide="' + idx + '"]');
        if (slide) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
        setActive(idx);
      });
    });

    // Mobile carousel: keep active thumb synced with scroll position.
    if (gallery && slides.length) {
      var sync = function () {
        if (window.innerWidth >= 990) return; // desktop grid shows all
        var mid = gallery.scrollLeft + gallery.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        setActive(best);
      };
      var raf;
      gallery.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });
    }

    // Cross-sell horizontal nav arrows.
    var track = root.querySelector('[data-pp-cross-track]');
    var prev = root.querySelector('[data-pp-cross-prev]');
    var next = root.querySelector('[data-pp-cross-next]');
    function scrollCross(dir) {
      if (!track) return;
      var amount = track.clientWidth;
      var target = track.scrollLeft + dir * amount;
      try { track.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) {}
      // Fallback: some environments ignore behavior:'smooth' (it can no-op). Force the position.
      track.scrollLeft = target;
    }
    if (prev) prev.addEventListener('click', function () { scrollCross(-1); });
    if (next) next.addEventListener('click', function () { scrollCross(1); });
  }

  function initAll() {
    document.querySelectorAll('.psylos-product').forEach(initProduct);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.psylos-product');
    if (root) { root.dataset.ppInit = ''; initProduct(root); }
  });

  /* ── Size chart modal ── */
  (function () {
    var modal = document.querySelector('[data-pp-sizechart]');
    if (!modal) return;
    function scOpen() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function scClose() { modal.hidden = true; document.body.style.overflow = ''; }
    document.querySelectorAll('[data-pp-sizechart-open]').forEach(function (b) { b.addEventListener('click', scOpen); });
    modal.querySelectorAll('[data-pp-sizechart-close]').forEach(function (b) { b.addEventListener('click', scClose); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) scClose(); });
    /* CM / INCHES unit toggle — CM is the stored base; inches = cm / 2.54 (size labels & non-numeric text pass through) */
    function scIsSize(s) { return /^(XS|S|M|L|XL|XXL|XXXL|[2-5]XL|F|FREE|フリー|ワンサイズ)$/i.test((s || '').trim()); }
    function scToInch(s) { return scIsSize(s) ? s : String(s).replace(/(\d+(?:\.\d+)?)/g, function (m) { return (parseFloat(m) / 2.54).toFixed(1); }); }
    modal.querySelectorAll('[data-unit-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var unit = b.getAttribute('data-unit-btn');
        modal.querySelectorAll('[data-unit-btn]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        modal.querySelectorAll('.sc-val').forEach(function (td) {
          var cm = td.getAttribute('data-cm') || '';
          td.textContent = (unit === 'in') ? scToInch(cm) : cm;
        });
      });
    });
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psylos-split-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    if (root.dataset.pssInit === '1') return;
    root.dataset.pssInit = '1';

    var track = root.querySelector('[data-pss-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pss-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pss-dot]'));
    var prevBtn = root.querySelector('[data-pss-prev]');
    var nextBtn = root.querySelector('[data-pss-next]');

    /* Seamless forward loop: clone the first slide onto the end; arriving at the
       clone silently warps back to the real first slide (no reverse scroll). */
    var realCount = slides.length;
    if (realCount > 1 && !track.querySelector('[data-pss-clone]')) {
      var clone = slides[0].cloneNode(true);
      clone.setAttribute('data-pss-clone', '1');
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('is-visible');
      track.appendChild(clone);
    }
    function warpToStart() {
      var snap = track.style.scrollSnapType, beh = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      void track.offsetWidth;
      track.style.scrollSnapType = snap;
      track.style.scrollBehavior = beh;
    }
    var warpT;
    function maybeWarp() {
      if (realCount < 2) return;
      /* use the clone's real offset — clientWidth*count drifts by rounding as slides grow */
      var c = track.querySelector('[data-pss-clone]');
      var edge = c ? c.offsetLeft : (track.clientWidth || 1) * realCount;
      if (track.scrollLeft >= edge - 2) warpToStart();
    }

    // Scroll-fade entrance via IntersectionObserver.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.2 });
      slides.forEach(function (s) { io.observe(s); });
    } else {
      slides.forEach(function (s) { s.classList.add('is-visible'); });
    }

    function currentIndex() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }
    function goTo(i) {
      var max = realCount > 1 ? realCount : slides.length - 1; /* allow stepping onto the clone */
      if (i < 0) i = 0;
      if (i > max) i = max;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    function syncDots() {
      if (!dots.length) return;
      var idx = currentIndex() % (realCount || 1);
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === idx);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-pss-dot'), 10) || 0);
      });
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncDots);
      if (warpT) clearTimeout(warpT);
      warpT = setTimeout(maybeWarp, 90); /* after the scroll settles on the clone, warp home */
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-pss]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pss]');
    if (root) { root.dataset.pssInit = ''; initSlider(root); }
  });
})();
(function () {
  function setupAutoplay(root) {
    if (root.dataset.pssAuto === '1') return;
    var track = root.querySelector('[data-pss-track]');
    var slides = root.querySelectorAll('[data-pss-slide]');
    if (!track || slides.length <= 1) return;
    root.dataset.pssAuto = '1';

    var MS = 8000;   // 自動送りの間隔 = 8秒
    var DUR = 1200;  // 遷移の長さ = 1.2秒（大きいほどゆっくり）
    var timer = null, resume = null;

    function curr() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }
    function ease(p) {
      return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
    }
    function animate(to, done) {
      var start = track.scrollLeft, dist = to - start;
      var t0 = null, snap = track.style.scrollSnapType, beh = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      function finish() {
        if (done) done(); /* must run while snap is still off, before it can re-snap */
        track.style.scrollSnapType = snap;
        track.style.scrollBehavior = beh;
      }
      if (Math.abs(dist) < 1) { finish(); return; }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / DUR, 1);
        track.scrollLeft = start + dist * ease(p);
        if (p < 1) { requestAnimationFrame(step); }
        else { finish(); }
      }
      requestAnimationFrame(step);
    }
    function jumpHome() {
      var snap = track.style.scrollSnapType, beh = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      void track.offsetWidth;
      track.style.scrollSnapType = snap;
      track.style.scrollBehavior = beh;
    }
    function go() {
      /* always advance rightward; never animate backwards */
      var hasClone = !!track.querySelector('[data-pss-clone]');
      var last = slides.length - 1; /* includes the clone when present */
      var i = curr() + 1;
      if (i > last) { jumpHome(); i = 1; if (i > last) i = last; } /* parked past the end: instant reset */
      var target = slides[i] ? slides[i].offsetLeft : track.clientWidth * i;
      if (hasClone && i === last) {
        animate(target, jumpHome); /* warp home the instant the clone lands — no event-debounce dependency */
      } else {
        animate(target);
      }
    }
    function start() { stop(); timer = setInterval(go, MS); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function bump() {
      stop();
      if (resume) clearTimeout(resume);
      resume = setTimeout(start, 5000);
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, bump, { passive: true });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    start();
  }
  function boot() { document.querySelectorAll('[data-pss]').forEach(setupAutoplay); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pss]');
    if (r) { r.dataset.pssAuto = ''; setupAutoplay(r); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
